import { createQueryKeys } from '@lukemorales/query-key-factory';
import {
  getBankTransactions,
  getBankLineCandidates,
} from '../admin/bank-transaction.service';
import { getData } from '../utils/functional/fp';

export const bankTransactions = createQueryKeys('bankTransactions', {
  list: (filters: Record<string, unknown>) => ({
    queryKey: [{ filters }],
    queryFn: () => getBankTransactions({ params: filters }).then(getData),
  }),
  candidates: (bankLineId: string) => ({
    queryKey: [{ bankLineId }],
    queryFn: () => getBankLineCandidates(bankLineId).then(getData),
  }),
});
